import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../styles';

const styles = css`
  position:relative;
  z-index: 0;
  padding: 70px 0 0 0;
  @media (min-width: 992px) {
    padding: 160px 0 0 0;
  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 70px;
    background-color: ${colors.brand1};
    @media (min-width: 992px) {
      height: 160px;
    }
  }
  .DetailHeader {
    background-color: ${colors.body};
    background-image: url('/images/pattern-01-dark.svg');
    background-position: center center;
    background-size: cover;
    @media(min-width: 992px) {
    }
  }
  .DetailMenu {
    display: none;
    @media (min-width: 992px) {
      display: block;
      width: 100%;
      background-color: ${colors.neutral};
      position:relative;
      z-index: 6;
      padding: 0;
    }
  }
  .DetailMenu_list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .DetailMenu_listItem {
    display: block;
    a {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: transparent;
      height: 60px;
      line-height: 1;
      color: ${colors.body};
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 1px;
      text-align: center;
      padding: 0 15px;
      border: 0;
      font-size: 14px;
      border-bottom: 5px solid transparent;
      &.active {
        background-color: ${colors.brand3};
        color: ${colors.white};
        border-bottom: 5px solid ${colors.brand3Darker};
      }
    }
  }
  .DetailOverview {
    display: block;
    position: relative;
    z-index: 6;
    margin: 15px 0;
    @media (min-width: 992px) {
      margin: 60px 0;
    }
  }
  .DetailOverview_headingWrapper {
    margin: 0 0 10px 0;
    padding: 0 0 10px 0;
    border-bottom: 1px solid ${colors.neutral};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    @media (min-width: 992px) {
      margin: 0 0 15px 0;
      padding: 0 0 15px 0;
    }
  }
  .DetailOverview_heading {
    font-size: 21px;
    line-height: 1;
    font-weight: 800;
    margin: 0;
    padding: 0 30px 0 0;
    @media (min-width: 992px) {
      font-size: 26px;
    }
  }
  .DetailOverview_subheading {
    font-size: 16px;
    font-weight: 400;
    display: block;
    @media (min-width: 992px) {
      font-size: 20px;
    }
  }
  .DetailOverview_mapButton {
    @media (min-width: 992px) {
      display: none;
    }
  }
  .DetailOverview_sectionWrapper {
    margin: 0 0 10px 0;
    padding: 0 0 10px 0;
    border-bottom: 1px solid ${colors.neutral};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    @media (min-width: 992px) {
      margin: 0 0 15px 0;
      padding: 0 0 15px 0;
    }
  }
  .DetailOverview_sectionItem {
    font-size: 15px;
    line-height: 1.2;
    font-weight: 400;
    margin: 0;
    width: 100%;
    @media (min-width: 992px) {
      font-size: 16px;
    }
    a {
      font-weight: 700;
    }
    &-count {
      padding: 10px 0;
      @media (min-width: 992px) {
        width: 50%;
        padding: 0;
      }
    }
  }
  .DetailOverview_price {
    font-size: 21px;
    line-height: 1;
    font-weight: 800;
    margin: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    @media (min-width: 992px) {
      font-size: 24px;
    }
  }
  .DetailOverview_priceLabel {
    font-size: 16px;
    font-weight: 400;
    line-height: 1;
    margin: 0 0 4px 0;
  }
  .DetailOverview_status {
    font-size: 15px;
    line-height: 1.2;
    font-weight: 400;
    margin: 0;
    display: flex;
    flex-direction: column;
    flex: 2;
    @media (min-width: 992px) {
      font-size: 16px;
    }
  }
  .DetailOverview_list {
    padding: 0;
    position: relative;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 10px 0;
    padding: 0 0 0 0;
    border-bottom: 1px solid ${colors.neutral};
    @media (min-width: 992px) {
      list-style: none;
      margin: 0 0 15px 0;
      padding: 0 0 0 0;
      justify-content: flex-start;
    }
  }
  .DetailOverview_listItem {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex-shrink: 0;
    align-items: center;
    text-align: left;
    padding: 0 15px 10px 0;
    line-height: 1;
    width: 33.333%;
    @media (min-width: 992px) {
      padding: 0 15px 15px 0;
    }
  }
  .DetailOverview_listItemValue {
    font-weight: 700;
    margin: 0 4px 0 0;
    font-size: 15px;
    @media (min-width: 992px) {
      font-size: 16px;
    }
  }
  .DetailOverview_listItemLabel {
    font-weight: 400;
    margin: 0 5px 0 0;
    font-size: 15px;
    @media (min-width: 992px) {
      font-size: 16px;
    }
  }
  .DetailSection {
    position: relative;
    .ScrollTarget {
      position: absolute;
      display: block;
      top: -40px;
    }
  }
  .DetailSection_headingWrapper {
    padding: 0;
    @media (min-width: 768px) {
     padding: 0 15px;
   }
  }
  .DetailSection_heading {
    color: ${colors.brand1};
    padding: 15px;
    background-image: url('/images/icon-plus.svg');
    background-position: calc(100% - 17px) center;
    background-repeat: no-repeat;
    background-size: 10px 10px;
    border-top: 1px solid ${colors.neutralDark};
    font-size: 18px;
    outline: 0 !important;
    margin: 0;
    @media (min-width: 992px) {
      font-size: 21px;
      padding: 15px;
      background-position: calc(100% - 15px) center;
    }
  }
  .NoToggleDesktop {
    @media (min-width: 992px) {
      .DetailSection_headingWrapper {
        text-align: center;
      }
      .DetailSection_heading {
        text-align: center;
        font-family: ${typography.Serif};
        font-size: 50px;
        line-height: 1;
        margin: 0 0 30px 0;
        display: inline-block;
        margin: 30px 0 45px 0;
        background-image: none;
        border: 0;
        &::before {
          content: '';
          height: 10px;
          border-top: 2px solid ${colors.neutral};
          border-bottom: 2px solid ${colors.neutral};
          display: inline-block;
          width: 234px;
          margin: 0 15px 8px 0;
        }
        &::after {
          content: '';
          display: block;
          display: inline-block;
          width: 234px;
          height: 10px;
          margin: 0 0 8px 15px;
          border-top: 2px solid ${colors.neutral};
          border-bottom: 2px solid ${colors.neutral};
          background-color: transparent;
        }
      }
    }
  }
  .DetailSection_heading-open {
    background-image: url('/images/icon-minus.svg');
    margin: 0 0 20px 0;
    background-color: ${colors.neutralLight};
  }
  .DetailSection_floorPlanImage {
    width: 100%;
    padding: 15px;
    height: 400px;
    object-fit: contain;
    border: 1px solid ${colors.neutralDark};
    margin: 0 0 30px 0;
    cursor: zoom-in;
  }
  .DetailSection_table, .SchoolList_list {
    list-style: none;
    padding: 0;
    padding-bottom: 45px;
    li:last-child {
      .DetailSection_tableContent, .DetailSection_tableLabel,
      .SchoolList_schoolName, .SchoolList_schoolLevel {
        border-bottom: 1px solid ${colors.neutralDark};
      }
    }
  }
  .SchoolList_school {
    display: flex;
  }
  .DetailSection_tableLabel, .SchoolList_schoolLevel {
    background-color: ${colors.neutralLight};
    border-top: 1px solid ${colors.neutralDark};
    padding: 10px 10px;
    font-weight: 700;
    font-size: 15px;
    height: 100%;
    @media (min-width: 992px) {
      font-size: 16px;
      padding: 15px 15px;
    }
  }
  .SchoolList_schoolLevel {
    width: 33.3333%;
    flex-grow: 0;
  }
  .DetailSection_tableContent, .SchoolList_schoolName {
    border-top: 1px solid ${colors.neutralDark};
    padding: 10px 10px;
    font-size: 15px;
    height: 100%;
    display: block;
    @media (min-width: 992px) {
      font-size: 16px;
      padding: 15px 45px;
    }
  }
  .SchoolList_schoolName {
    width: 66.6666%;
    flex-grow: 0;
  }
`;

function DetailPageWrapper({ children }) {
  return (
    <div className={styles}>
      {children}
    </div>
  );
}

DetailPageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

DetailPageWrapper.defaultProps = {
  community: undefined,
};

export default(DetailPageWrapper);



// WEBPACK FOOTER //
// ./src/components/DetailPageWrapper.js